export default __webpack_public_path__ + "static/media/trumpet.121f291e.mp3";